/** Prefer DRB ID for display; admin Login ID 0001 is the only Login ID still shown. */
export function getEmployeeDisplayId(employee?: {
  employeeId?: string | number | null;
  drbEmployeeNumber?: string | number | null;
} | null): string {
  if (!employee) {
    return '—';
  }
  const drbId = employee.drbEmployeeNumber != null ? String(employee.drbEmployeeNumber).trim() : '';
  if (drbId) {
    return drbId;
  }
  const loginId = employee.employeeId != null ? String(employee.employeeId).trim() : '';
  if (loginId === '0001' || loginId === '1') {
    return loginId;
  }
  return '—';
}

/** Display name: preferred name when set, otherwise first and last name. */
export function getEmployeeDisplayName(employee?: {
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
} | null): string {
  if (!employee) {
    return '—';
  }
  const preferred = employee.preferredName?.trim();
  if (preferred) {
    return preferred;
  }
  return [employee.firstName, employee.lastName].filter(Boolean).join(' ').trim() || '—';
}
